export type AdminJobAction = 'cancel' | 'expire'

const CANCELLABLE_STATES = new Set([
  'available',
  'pending',
  'retryable',
  'running',
  'scheduled',
])

export function canCancelAdminJob(state: string, cancelRequestedAt?: string) {
  return !cancelRequestedAt && CANCELLABLE_STATES.has(state)
}

export function canExpireAdminJob(state: string) {
  return state === 'completed'
}

type Fetcher = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>

export async function runAdminJobAction(
  fetcher: Fetcher,
  jobId: number,
  action: AdminJobAction,
) {
  const path = action === 'cancel'
    ? `/v0/admin/jobs/${jobId}/cancel`
    : `/v0/admin/jobs/${jobId}`
  const method = action === 'cancel' ? 'POST' : 'DELETE'
  const response = await fetcher(path, { method })
  if (!response.ok) {
    const body = await response.json().catch(() => null)
    throw new Error(body?.detail || body?.title || `Failed to ${action} background job`)
  }
  return response.json()
}
